const allProductIds = [
  "42278394921177",
  "42278397706457",
  "44031358107865",
  "41342157258944",
  "42278395183321",
  "42278397280473",
  "42278398230745",
  "42278396985561",
  "41342157226176",
  "42278396297433",
  "43014211895513",
  "42278399869145",
  "42278395936985",
  "41342157422784",
  "42278398656729",
  "43900049129689",
  "43852370968793",
  "45910581575897",
  "45869685276889",
  "45434409713881",
  "45869690749145",
  "45910584459481"
];

const freeProductIds = ["46005845885145", "46005846507737"];
// const freeProductIds = ["46005845885145", "46005846507737"];
const productsRequiredForTheKit = 4;
const byokItems = [];
let chosenFreeProduct = null;
const selectedItems = [];
const selected = "s1";

let variantsToRemove = ["45297753129177", "45888875856089", "43968095518937", "45297754439897", "44530202837209", "44530202411225", "44530201690329", "45484132040921", "45648655450329", "45760888668377", "45760889258201", "55259575255421","56114141462909","56114130485629","56114137170301","44721320100057"];
let priceToKeepVariants = 6000;

function checkForFreeGiftsInCart(cart) {
    return cart.items.some(item => variantsToRemove.includes(item.variant_id.toString()));
}

function toggleFreeGiftSection(display) {
    let freeGiftsSection = document.querySelector('.slidecarthq .free-gifts');
    if (freeGiftsSection) {
        freeGiftsSection.style.display = display ? 'block' : 'none';
    }
}

function toggleAnnouncementsSection(display) {
    let announcementsSection = document.querySelector('.slidecarthq .announcements');
  
    if (announcementsSection) {
        announcementsSection.style.display = display ? 'block' : 'none';
    }
}

window.SLIDECART_UPDATED = function (cart) {
  let { total_price } = cart;

    if(total_price < priceToKeepVariants) {
      variantsToRemove.forEach(variant => {
        document.querySelector(`.slidecarthq .item[data-variant-id='${variant}'] button.remove`)?.click();
      })
      toggleAnnouncementsSection(true); 
    } else {
      toggleAnnouncementsSection(false); 
    }

    let hasFreeGift = checkForFreeGiftsInCart(cart);
    toggleFreeGiftSection(!hasFreeGift);
  
  Shopify.getCart(function (newcart) {
    if (
      newcart.item_count !== cart.item_count ||
      newcart.total_price !== cart.total_price ||
      newcart.token !== cart.token ||
      newcart.items.length !== cart.items.length
    ) {
      window.SLIDECART_CLOSE();
      window.SLIDECART_UPDATE(newcart);
      window.SLIDECART_OPEN();
    }
  }, cart);

  const validProducts = cart.items.filter(
    (item) => allProductIds.indexOf(item.id.toString()) > -1
  );
  const validProductsQty = validProducts
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  const validFreeProducts = cart.items.filter(
    (item) => freeProductIds.indexOf(item.id.toString()) > -1
  );
  const validFreeProductsQty = validFreeProducts
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  let realKitCount = validFreeProductsQty;
  let expectedKitCount = ~~(validProductsQty / 4);
  const updates = {};

  if (realKitCount === 0 || realKitCount === expectedKitCount) return;

  while (realKitCount > expectedKitCount) {
    const id = validFreeProducts[validFreeProducts.length - 1].id;
    const quantity =
      validFreeProducts[validFreeProducts.length - 1].quantity - 1;
    validFreeProducts[validFreeProducts.length - 1].quantity = quantity;
    updates[id] = quantity;
    realKitCount -= 1;
  }

  jQuery
    .post(window.Shopify.routes.root + "cart/update.js", { updates })
    .complete(() => {
      if (realKitCount <= expectedKitCount) {
        window.SLIDECART_UPDATE();
      }
    });
};

function addItemToByok(id, quantity = 1, img = "") {
  const isProductFromCampaign = allProductIds.indexOf(id) > -1;
  const isFreeProduct = freeProductIds.indexOf(id) > -1;
  if (!isProductFromCampaign && !isFreeProduct) {
    return;
  }

  if (isFreeProduct) {
    if (chosenFreeProduct === null) {
      chosenFreeProduct = id;
      jQuery("#freeItem").attr("src", img);
      jQuery("#freeItem").attr("src", img).show();
      jQuery(".block-1").children()[0].style.display = "block";
      jQuery("#freeItem" + id + "AddToKit").hide();
      jQuery("#freeItem" + id + "RemoveFromKit").show();

      if (id === "43420059402457") {
        jQuery("#freeItem43420057370841AddToKit").prop("disabled", true);
        jQuery("#freeItem43420057370841AddToKit").css("opacity", 0.7);
      } else {
        jQuery("#freeItem43420059402457AddToKit").prop("disabled", true);
        jQuery("#freeItem43420059402457AddToKit").css("opacity", 0.7);
      }
    }
    updateHtml();
    jQuery(".step-1").hide();
    if (selectedItems.length >= 4) {
      jQuery(".step-3").show();
      jQuery(".block-1").removeClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
    } else {
      jQuery(".step-2").show();
      jQuery(".block-1").removeClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
      jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
    }

    const total = byokItems
      .map((item) => item.quantity)
      .reduce(function (a, b) {
        return a + b;
      }, 0);

    jQuery(".step-2").text("Select " + (4 - total) + " more products");
    return;
  }

  let totalQuantity = byokItems
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);

  if (totalQuantity >= 4) {
    return;
  }

  const isAlreadyAdded = byokItems.findIndex((item) => item.id === id) > -1;
  if (!isAlreadyAdded) {
    byokItems.push({ id, quantity: quantity });
    selectedItems.push({ id, img });
    jQuery(".item-" + selectedItems.length).attr("src", img);
    jQuery(".item-" + selectedItems.length).show();
    jQuery(".block-" + (selectedItems.length + 1)).children()[0].style.display =
      "block";

    totalQuantity = byokItems
      .map((item) => item.quantity)
      .reduce(function (a, b) {
        return a + b;
      }, 0);
    jQuery(".step-2").text("Select " + (4 - totalQuantity) + " more products");

    if (totalQuantity === 4 && chosenFreeProduct) {
      jQuery(".step-1").hide();
      jQuery(".step-2").hide();
      jQuery(".step-3").show();
      jQuery(".block-1").removeClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
      return;
    }

    if (!chosenFreeProduct) {
      jQuery(".block-1").addClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
      return;
    }

    jQuery(".block-1").removeClass("selected");
    jQuery(".block-2").removeClass("selected");
    jQuery(".block-3").removeClass("selected");
    jQuery(".block-4").removeClass("selected");
    jQuery(".block-5").removeClass("selected");
    jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
    return;
  }

  const itemIndex = byokItems.findIndex((item) => item.id == id);
  if (itemIndex < 0) return;

  byokItems[itemIndex].quantity += quantity;
  selectedItems.push({ id, img });
  jQuery(".item-" + selectedItems.length).attr("src", img);
  jQuery(".item-" + selectedItems.length).show();
  jQuery(".block-" + (selectedItems.length + 1)).children()[0].style.display =
    "block";

  totalQuantity = byokItems
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  jQuery(".step-2").text("Select " + (4 - totalQuantity) + " more products");

  if (totalQuantity === 4 && chosenFreeProduct) {
    jQuery(".step-1").hide();
    jQuery(".step-2").hide();
    jQuery(".step-3").show();
    jQuery(".block-1").removeClass("selected");
    jQuery(".block-2").removeClass("selected");
    jQuery(".block-3").removeClass("selected");
    jQuery(".block-4").removeClass("selected");
    jQuery(".block-5").removeClass("selected");
  }

  if (!chosenFreeProduct) {
    jQuery(".block-1").addClass("selected");
    jQuery(".block-2").removeClass("selected");
    jQuery(".block-3").removeClass("selected");
    jQuery(".block-4").removeClass("selected");
    jQuery(".block-5").removeClass("selected");
    return;
  }

  jQuery(".block-1").removeClass("selected");
  jQuery(".block-2").removeClass("selected");
  jQuery(".block-3").removeClass("selected");
  jQuery(".block-4").removeClass("selected");
  jQuery(".block-5").removeClass("selected");
  jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
}

function removeFreeItem() {
  jQuery("#freeItem").hide();
  jQuery("#freeItem43420059402457AddToKit").show();
  jQuery("#freeItem43420059402457RemoveFromKit").hide();
  jQuery("#freeItem43420057370841AddToKit").show();
  jQuery("#freeItem43420057370841RemoveFromKit").hide();
  jQuery("#freeItem43420057370841AddToKit").prop("disabled", false);
  jQuery("#freeItem43420059402457AddToKit").prop("disabled", false);
  jQuery("#freeItem43420057370841AddToKit").css("opacity", 1);
  jQuery("#freeItem43420059402457AddToKit").css("opacity", 1);
  jQuery(".step-1").show();
  jQuery(".step-2").hide();
  jQuery(".step-3").hide();
  jQuery(".step-4").hide();
  jQuery(".block-1").addClass("selected");
  jQuery(".block-2").removeClass("selected");
  jQuery(".block-3").removeClass("selected");
  jQuery(".block-4").removeClass("selected");
  jQuery(".block-5").removeClass("selected");
  jQuery(".block-1").children()[0].style.display = "none";
}

function getProductId(id) {
  return selectedItems[id].id;
}

function removeItemFromByok(id) {
  const itemIndex = byokItems.findIndex((item) => item.id == id);
  if (itemIndex < 0) {
    if (chosenFreeProduct === id) {
      chosenFreeProduct = null;
      removeFreeItem();
    }
    updateHtml();
    return;
  }

  const quantity = byokItems[itemIndex].quantity;
  if (quantity <= 1) {
    byokItems.splice(itemIndex, 1);
    updateHtml();
    const index = selectedItems.findIndex((i) => i.id === id);
    selectedItems.splice(index, 1);
    jQuery(".item-1").hide();
    jQuery(".item-2").hide();
    jQuery(".item-3").hide();
    jQuery(".item-4").hide();

    selectedItems.map((item, i) => {
      jQuery(".item-" + (i + 1)).attr("src", item.img);
      jQuery(".item-" + (i + 1)).show();
    });

    for (let i = 1; i <= 4; i++) {
      jQuery(".block-" + (i + 1)).children()[0].style.display =
        i <= selectedItems.length ? "block" : "none";
    }

    if (chosenFreeProduct) {
      jQuery(".block-1").removeClass("selected");
      jQuery(".block-2").removeClass("selected");
      jQuery(".block-3").removeClass("selected");
      jQuery(".block-4").removeClass("selected");
      jQuery(".block-5").removeClass("selected");
      jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
    }

    const total = byokItems
      .map((item) => item.quantity)
      .reduce(function (a, b) {
        return a + b;
      }, 0);
    jQuery(".step-2").text("Select " + (4 - total) + " more products");
    jQuery(".step-3").hide();
    jQuery(".step-2").show();

    return;
  }

  byokItems[itemIndex].quantity -= 1;

  const index = selectedItems.findIndex((i) => i.id === id);
  selectedItems.splice(index, 1);
  jQuery(".item-1").hide();
  jQuery(".item-2").hide();
  jQuery(".item-3").hide();
  jQuery(".item-4").hide();
  selectedItems.map((item, i) => {
    jQuery(".item-" + (i + 1)).attr("src", item.img);
    jQuery(".item-" + (i + 1)).show();
  });

  for (let i = 1; i <= 4; i++) {
    jQuery(".block-" + (i + 1)).children()[0].style.display =
      i <= selectedItems.length ? "block" : "none";
  }

  const total = byokItems
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);
  jQuery(".step-2").text("Select " + (4 - total) + " more products");
  jQuery(".step-3").hide();
  jQuery(".step-2").show();

  if (chosenFreeProduct) {
    jQuery(".block-1").removeClass("selected");
    jQuery(".block-2").removeClass("selected");
    jQuery(".block-3").removeClass("selected");
    jQuery(".block-4").removeClass("selected");
    jQuery(".block-5").removeClass("selected");
    jQuery(".block-" + (selectedItems.length + 2)).addClass("selected");
  }
  return;
}

function addItemsToCart() {
  const productsToBeAdded = byokItems;
  productsToBeAdded.push({ id: chosenFreeProduct, quantity: 1 });

  jQuery
    .post(window.Shopify.routes.root + "cart/add.js", {
      items: productsToBeAdded,
    })
    .complete(() => {
      window.SLIDECART_UPDATE(() => openSlideCart());
      jQuery(".step-3").hide();
      jQuery(".step-4").show();
    });
}

function updateHtml() {
  const totalQuantity = byokItems
    .map((item) => item.quantity)
    .reduce(function (a, b) {
      return a + b;
    }, 0);

  if (totalQuantity >= productsRequiredForTheKit) {
    console.log(chosenFreeProduct);
    if (chosenFreeProduct != null) {
      jQuery(".ready").show();
      jQuery(".missing-free-product").hide();
    } else {
      jQuery(".ready").hide();
      jQuery(".missing-free-product").show();
    }
  } else {
    jQuery(".ready").hide();
    jQuery(".missing-free-product").hide();
  }
}

function getCurrentItems() {
  console.log(byokItems);
}

function openSlideCart() {
  window.SLIDECART_OPEN();
}

function openModal(img, text, id) {
  jQuery(".modalImage").attr("src", img);
  jQuery(".modalHeading").text(text);
  const element = jQuery(".productDescription-" + id).clone()[0];
  element.style.display = "block";
  jQuery(".modalDescription").empty();
  jQuery(".modalDescription").append(element);
  jQuery(".modalBtn").empty();
  jQuery(".modalBtn").append(
    `<button onClick="addItemToByok('` +
      id +
      `', 1, '` +
      img +
      `')" class="btn Button Button--primary quickButton addToKit" style="margin-top:0;">Add to Kit</button></div>`
  );
  jQuery(".modalHolder").show();
}

function closeModal() {
  jQuery(".modalHolder").hide();
}

// jQuery('.addToKit').click(function() {
//   if(jQuery('#freeItem').is(':visible')){
//     jQuery('.block-1').addClass('crossVisible');
//   };

//   if(jQuery('img.item-2').is(':visible')){
//     jQuery('.block-2').addClass('crossVisible');
//   };

//   if(jQuery('img.item-3').is(':visible')){
//     jQuery('.block-3').addClass('crossVisible');
//   };

//   if(jQuery('img.item-4').is(':visible')){
//     jQuery('.block-4').addClass('crossVisible');
//   };

//   if(jQuery('img.item-5').is(':visible')){
//     jQuery('.block-5').addClass('crossVisible');
//   };
// });

// window.SLIDECART_REMOVED_FROM_CART = function({ id }) {
//   const isByokProduct = allProductIds.indexOf(id.toString()) > -1;
//   const isByokFreeProduct = freeProductIds.indexOf(id.toString()) > -1;
//   if (!isByokProduct || !isByokFreeProduct) return;

//   removeItemFromByok(id.toString());
// }

// window.SLIDECART_ADD_TO_CART = function({ id, quantity }) {
//   const isByokProduct = allProductIds.indexOf(id.toString()) > -1;
//   const isByokFreeProduct = freeProductIds.indexOf(id.toString()) > -1;
//   if (!isByokProduct || !isByokFreeProduct) return;

//   addItemToByok(id.toString());
// }
